import { useEffect, useState } from 'react';

import { StringsToOptions } from 'src/compass/shared/util/StringsToOptions';
import useAddMutation from 'src/compass/shared/hooks/reactQuery/useAddMutation';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import { getParsedHTML } from 'src/compass/shared/util/getParsedHTML';

import CasSelect from '../../../CasSelect/CasSelect';
import CasPanel from '../../../CasPanel/CasPanel';
import { IDataTableConfig } from './CasTableDataNode';

interface Props {
  dataObject: IDataTableConfig['dataObject'];
  renderDataObjectUrl: string;
  nodeKey: string;
}

export enum CasTableNodeLayout {
  Basic = 'Basic',
  Current_Value = 'Current Value',
  Prelim_Settle = 'Prelim Settle',
}

const LAYOUT_OPTIONS = StringsToOptions([
  CasTableNodeLayout.Basic,
  CasTableNodeLayout.Current_Value,
  CasTableNodeLayout.Prelim_Settle,
]);

export function CasTableNodeRenderer({ renderDataObjectUrl, dataObject, nodeKey }: Props) {
  const [layout, setLayout] = useState(dataObject.layout ?? '');

  const { data, isPending, mutate } = useAddMutation({
    url: renderDataObjectUrl,
    showLoader: false,
  });

  useEffect(() => {
    mutate({ ...dataObject, layout });
  }, [mutate]);

  return (
    <CasPanel variant="outlined" maxHeight="200px" data-table-key={nodeKey}>
      <CasSelect
        label="Layout"
        value={layout}
        onChange={(_, value) => {
          setLayout(value);
          mutate({ ...dataObject, layout: value });
        }}
        options={LAYOUT_OPTIONS}
      />
      {isPending || !data ? (
        <CasLoader />
      ) : (
        <div style={{ fontSize: '12px' }}>{getParsedHTML(data as string)}</div>
      )}
    </CasPanel>
  );
}
